import { Injectable } from '@angular/core';

@Injectable()

export class TextService {
  emptyTextDisplay: string = 'Web Enrollment';
  constructor() {}
  get(): string {
    return this.emptyTextDisplay;
  }
  set(emptyTextDisplay: string) {
    this.emptyTextDisplay = emptyTextDisplay;
  }
}
